import { DialogRef } from '@angular/cdk/dialog';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Tooltip } from 'bootstrap/dist/js/bootstrap.esm';

import { UserValidators } from '@app/classes/user-validators.class';
import { MustMatchForm2 } from '@app/helpers/must-match-form.validator';
import { AuthService, UserService } from '@app/services';
import { ModalService } from '@app/services/modal/modal.service';
import { TextValidators } from '@app/services/validators';
import { catchError } from 'rxjs';

@Component({
  selector: 'mnf-user-settings-change-password',
  templateUrl: './user-settings-change-password.component.html',
  styleUrls: ['./user-settings-change-password.component.scss']
})
export class UserSettingsChangePasswordComponent implements OnInit {
  passwordForm: FormGroup;

  passwordFlag = 'password';
  passwordFlag2 = 'password';

  actualEmail: string;

  constructor(
    private readonly userServ: UserService,
    private readonly modal: ModalService,
    private readonly authServ: AuthService,
    private readonly dialogRef: DialogRef,
    private readonly toastr: ToastrService
  ) { }

  get actual() {
    return this.passwordForm.controls.actual;
  }

  get password() {
    return this.passwordForm.controls.password;
  }

  get confPassword() {
    return this.passwordForm.controls.confirmPassword;
  }

  ngOnInit() {
    this.userServ.getUserInf().subscribe((user: { email: string }) => {
      this.actualEmail = user.email;
    });

    this.passwordForm = new FormGroup({
      actual: new FormControl('', [
        Validators.required,
        Validators.minLength(8)
      ]),
      password: new FormControl('', [Validators.compose([
        Validators.required,
        TextValidators.password,
      ])]),
      confirmPassword: new FormControl('', [
        Validators.required
      ])
    }, {
      updateOn: 'blur',
      validators: [MustMatchForm2('password', 'confirmPassword', 'notMatchPass')]
    }
    );

    this.onEmailChange(this.actualEmail);

  }

  changePass() {
    if (this.passwordForm.valid) {
      const { password, actual } = this.passwordForm.value;

      this.authServ.changePassword(actual, password)
      .pipe(
         catchError((err) => {
            console.log(err?.message);
            return err;
         })
      )
      .subscribe(r => {
        const modal = this.modal.modalCustom({
          img: 'https://static.monific.com/assets/assets-app/images/modals/contrasena_cambiada.svg',
          title: 'Tu contraseña ha cambiado.',
          message: 'Por seguridad cambia tu contraseña constatemente y guardala bien.',
          buttonText: 'Continuar'
        });

        modal.beforeClosed().subscribe(() => this.dialogRef.close(true))
      });
    }
  }

  // Función para crear la instancia de FormControl para el campo de contraseña
  createPasswordFormControl(passwordValue: string, email: string): FormControl {
    return new FormControl(passwordValue, [
       Validators.required,
       TextValidators.password,
       (control: AbstractControl) => UserValidators.passwordEmailMatchValidator(email, { emailViolation: true })(control)
    ]);
  }

  onEmailChange(emailValue: string) {
    const passwordControl = this.passwordForm.get('password');
    const emailValueWithoutDomain = emailValue.split('@')[0];
    if (passwordControl) {
       const currentPasswordValue = passwordControl.value;
       this.passwordForm.setControl('password', this.createPasswordFormControl(currentPasswordValue, emailValueWithoutDomain));
    }
 }

  close() {
    this.dialogRef.close();
  }

  ngAfterViewInit(): void {
    Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"]')).forEach(tooltipNode => new Tooltip(tooltipNode));
  }

}
